var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChuva(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 42,
    viewBox: "0 0 45 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.7771 16.5182C39.7545 16.5182 39.734 16.5243 39.7119 16.5246C40.1243 15.5705 40.3554 14.5197 40.3554 13.4143C40.3554 9.07963 36.8413 5.56555 32.5066 5.56555C30.9747 5.56555 29.5499 6.0114 28.3418 6.77036C26.7075 2.79863 22.8038 0 18.2426 0C12.2111 0 7.32204 4.88923 7.32204 10.9205C7.32204 11.3762 7.35899 11.8229 7.41322 12.264C7.38239 12.2637 7.35287 12.2594 7.32204 12.2594C3.27837 12.2594 0 15.5375 0 19.5816C0 23.6253 3.27837 26.9035 7.32204 26.9035H39.7773C42.6452 26.9035 44.97 24.5787 44.97 21.7107C44.97 18.8428 42.6452 16.518 39.7773 16.518L39.7771 16.5182Z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.39 39.6975C13.5079 41.5325 11.3052 42.3052 9.47016 41.4231C7.63517 40.541 6.86243 38.3383 7.7445 36.5033C8.62679 34.6683 14.331 31.3105 14.331 31.3105C14.331 31.3105 15.2721 37.8625 14.39 39.6975Z",
    fill: "#BED7F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5571 39.6975C22.6752 41.5325 20.4724 42.3052 18.6374 41.4231C16.8022 40.541 16.0297 38.3383 16.9118 36.5033C17.7941 34.6683 23.4982 31.3105 23.4982 31.3105C23.4982 31.3105 24.4394 37.8625 23.5571 39.6975Z",
    fill: "#BED7F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.854 39.6975C31.9719 41.5325 29.7692 42.3052 27.9342 41.4231C26.0992 40.541 25.3267 38.3383 26.2085 36.5033C27.0908 34.6683 32.795 31.3105 32.795 31.3105C32.795 31.3105 33.7361 37.8625 32.854 39.6975Z",
    fill: "#BED7F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChuva);
export default __webpack_public_path__ + "static/media/chuva.8659ae12de4a19326bcadb568ca1b5d7.svg";
export { ForwardRef as ReactComponent };